import { TemplateElement, defineElement, html } from '@webtides/element-js';
import { classMap, when } from '@webtides/element-js/src/dom-parts/directives';
import style from './button.css';

/**
 * @property {string} type
 * @property {string} href
 * @property {boolean} disabled
 * @property {string} variant
 * @property {string} on
 */
export default class Button extends TemplateElement {
    constructor() {
        super({ styles: [style], shadowRender: true, propertyOptions: { variant: { reflect: true } } });
    }

    properties() {
        return {
            type: 'button',
            href: '',
            disabled: false,
            variant: 'secondary', // 'highlight' || 'primary' || 'secondary' || 'tertiary' || 'quaternary'
            on: '', // '' || 'default'
        };
    }

    events() {
        return {
            button: {
                click: (event) => {
                    if (this.type === 'submit') {
                        const form = this.closest('FORM');
                        form.requestSubmit();
                    }
                },
            },
        };
    }

    template() {
        const classes = {
            'is-highlight': this.variant === 'highlight',
            'is-primary': this.variant === 'primary',
            'is-secondary': this.variant === 'secondary',
            'is-tertiary': this.variant === 'tertiary',
            'is-quaternary': this.variant === 'quaternary',
            'on-default': this.on === 'default',
        };
        return html`
            ${when(
                this.href,
                html`
                    <a
                        href="${this.href}"
                        class="${classMap(classes)}"
                        type="${this.type}"
                        ?disabled="${this.disabled}"
                    >
                        ${when(this.variant === 'highlight', html` <span class="gradient"></span> `)}
                        <slot></slot>
                        <slot name="suffix"></slot>
                    </a>
                `,
                html`
                    <button class="${classMap(classes)}" type="${this.type}" ?disabled="${this.disabled}">
                        ${when(this.variant === 'highlight', html` <span class="gradient"></span> `)}
                        <slot></slot>
                        <slot name="suffix"></slot>
                    </button>
                `,
            )}
        `;
    }
}

defineElement('mb-button', Button);
